import apiHandler from "../core/apiHandler";

const purchaseInvalidationApi = apiHandler('purchases/invalidation');

export default purchaseInvalidationApi;
